import React, { useEffect, useState } from "react";
import {
  HeaderBar,
  ImageContainer,
  NavItem,
  NavContainer,
  UserDetailContainer,
  UserName,
  UserType,
  HeaderActionSection
} from "./styled/Header.styled";
import { IconButton, Badge, Menu, Avatar, MenuItem } from "@mui/material";
import { IoNotifications } from "react-icons/io5";
import { RiArrowDropDownLine } from "react-icons/ri";
import { Link, useLocation } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import Drawyer from "./Drawyer";
import { getCurrentUserDetails } from "../services/api/users.api";
import { toast } from "react-toastify";
import { deleteNotifications } from "../services/api/header.api";

const Header = () => {
  let location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [newUpload, setNewUpload] = useState(true);
  const [newLandingHome, setNewLandingHome] = useState(true);
  const [dashboard, setDashboard] = useState(false);
  const [processedFiles, setProcessedFiles] = useState(false);
  const [users, setUsers] = useState(false);
  const [models, setModels] = useState(false);
  const [modelPermissions, setModelPermissions] = useState(false);
  const [activityLog, setActivityLog] = useState(false);
  const [reqModels, setRequestModels] = useState(false);
  const [webMap, setWebMap] = useState(false);
  const [userDetails, setUserDetails] = useState({});

  const { instance } = useMsal();
  const user = JSON.parse(localStorage.getItem("user"));
  const [openDrawyer, setOpenDrawyer] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const updateNotifications = async () => {
      try {
        const dataUser = await getCurrentUserDetails();
        setNotificationCount(dataUser?.notifications?.length);
        setNotifications(dataUser?.notifications);
      } catch (err) {}
    };
    updateNotifications();
    const interval = setInterval(() => {
      updateNotifications();
    }, 15*60000); // 15 min
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setUserDetails(user);
  }, []);

  function handleLogout(i) {
    instance.logoutRedirect().catch((e) => {
      console.error(e);
    });
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/; Secure; SameSite=Lax");
    });
    localStorage.clear();
    sessionStorage.clear();
  }

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const resetHeaders = () => {
    setNewUpload(false);
    setNewLandingHome(false);
    setProcessedFiles(false);
    setUsers(false);
    setModels(false);
    setModelPermissions(false);
    setActivityLog(false);
    setRequestModels(false);
    setWebMap(false);
    setDashboard(false);
  };

  useEffect(() => {
    const { pathname } = location;
    resetHeaders();
    if (pathname === "/new-upload") setNewUpload(true);
    else if (pathname === "/home") setNewLandingHome(true);
    else if (pathname === "/processed-files") setProcessedFiles(true);
    else if (pathname === "/users") setUsers(true);
    else if (pathname === "/models") setModels(true);
    else if (pathname === "/model-permissions") setModelPermissions(true);
    else if (pathname === "/activity-log") setActivityLog(true);
    else if (pathname === "/req-models") setRequestModels(true);
    else if (pathname === "/web-map") setWebMap(true);
    else if (pathname === "/dashboard") setDashboard(true);
  }, [location]);

  const resetAllNotifications = async () => {
    try {
      if (userDetails) {
        await deleteNotifications(userDetails._id);
      }
    } catch (err) {
      toast.error("Error while clearing notifications.", {
        theme: "colored",
      });
    }
  };

  return (
    <>
      <HeaderBar>
        <ImageContainer>
          <img
            src={"/assets/logo.png"}
            alt="logo"
            style={{
              height: "50px",
              width: "100%",
              objectFit: "contain"
            }}
          />
        </ImageContainer>
        <Drawyer
          open={openDrawyer}
          setOpen={setOpenDrawyer}
          notifications={notifications}
          setNotificationCount={setNotificationCount}
          setNotifications={setNotifications}
        />
        <NavContainer>
          {userDetails?.user_role === "admin" && (
            <>
              {userDetails?.web_portal_access && (
                <Link
                  to="/home"
                  // onClick={() => (window.location.href = "/home")}
                >
                  <NavItem selected={newLandingHome}>HOME</NavItem>
                </Link>
              )}
              {userDetails?.dashboard_access && (
                <Link
                  to="/dashboard"
                >
                  <NavItem selected={dashboard}>DASHBOARD</NavItem>
                </Link>
              )}
              {userDetails?.web_map_access === true && (
                <Link
                  to="/web-map"
                  // onClick={() => (window.location.href = "/web-map")}
                >
                  <NavItem selected={webMap}>Web Map</NavItem>
                </Link>
              )}
              {userDetails?.web_portal_access && (
                <Link
                  to="/new-upload"
                  // onClick={() => (window.location.href = "/new-upload")}
                >
                  <NavItem selected={newUpload}>Data Extract</NavItem>
                </Link>
              )}
              {userDetails?.web_portal_access && (
                <Link
                  to="/processed-files"
                  // onClick={() => (window.location.href = "/processed-files")}
                >
                  <NavItem selected={processedFiles}>Processed Files</NavItem>
                </Link>
              )}
              {userDetails?.web_portal_access && (
                <Link
                  to="/users"
                  // onClick={() => (window.location.href = "/users")}
                >
                  <NavItem selected={users}>Users</NavItem>
                </Link>
              )}
              {userDetails?.web_portal_access && (
                <Link
                  to="/models"
                  // onClick={() => (window.location.href = "/models")}
                >
                  <NavItem selected={models}>Modules</NavItem>
                </Link>
              )}
              {userDetails?.web_portal_access && (
                <Link
                  to="/model-permissions"
                  // onClick={() => (window.location.href = "/model-permissions")}
                >
                  <NavItem selected={modelPermissions}>
                    Module Permissions
                  </NavItem>
                </Link>
              )}
              {userDetails?.web_portal_access && (
                <Link
                  to="/activity-log"
                  // onClick={() => (window.location.href = "/activity-log")}
                >
                  <NavItem selected={activityLog}>Activity Log</NavItem>
                </Link>
              )}
            </>
          )}
          {userDetails?.user_role === "super_admin" && (
            <>
              {userDetails?.web_portal_access && (
                <Link
                  to="/home"
                  // onClick={() => (window.location.href = "/home")}
                >
                  <NavItem selected={newLandingHome}>HOME</NavItem>
                </Link>
              )}
              {userDetails?.dashboard_access && (
                <Link
                  to="/dashboard"
                >
                  <NavItem selected={dashboard}>DASHBOARD</NavItem>
                </Link>
              )}
              {userDetails?.web_map_access === true && (
                <Link
                  to="/web-map"
                  // onClick={() => (window.location.href = "/web-map")}
                >
                  <NavItem selected={webMap}>Web Map</NavItem>
                </Link>
              )}
              {userDetails?.web_portal_access && (
                <Link
                  to="/new-upload"
                  // onClick={() => (window.location.href = "/new-upload")}
                >
                  <NavItem selected={newUpload}>Data Extract</NavItem>
                </Link>
              )}
              {userDetails?.web_portal_access && (
                <Link
                  to="/processed-files"
                  // onClick={() => (window.location.href = "/processed-files")}
                >
                  <NavItem selected={processedFiles}>Processed Files</NavItem>
                </Link>
              )}
              {userDetails?.web_portal_access && (
                <Link
                  to="/users"
                  // onClick={() => (window.location.href = "/users")}
                >
                  <NavItem selected={users}>Users</NavItem>
                </Link>
              )}
              {userDetails?.web_portal_access && (
                <Link
                  to="/models"
                  // onClick={() => (window.location.href = "/models")}
                >
                  <NavItem selected={models}>Modules</NavItem>
                </Link>
              )}
              {userDetails?.web_portal_access && (
                <Link
                  to="/model-permissions"
                  // onClick={() => (window.location.href = "/model-permissions")}
                >
                  <NavItem selected={modelPermissions}>
                    Module Permissions
                  </NavItem>
                </Link>
              )}
              {userDetails?.web_portal_access && (
                <Link
                  to="/activity-log"
                  // onClick={() => (window.location.href = "/activity-log")}
                >
                  <NavItem selected={activityLog}>Activity Log</NavItem>
                </Link>
              )}
            </>
          )}
          {userDetails?.user_role === "user" && (
            <>
              {userDetails?.web_portal_access && (
                <Link
                  to="/home"
                  // onClick={() => (window.location.href = "/home")}
                >
                  <NavItem selected={newLandingHome}>HOME</NavItem>
                </Link>
              )}
              {userDetails?.dashboard_access && (
                <Link
                  to="/dashboard"
                >
                  <NavItem selected={dashboard}>DASHBOARD</NavItem>
                </Link>
              )}

              {userDetails?.web_map_access === true && (
                <Link
                  to="/web-map"
                  // onClick={() => (window.location.href = "/web-map")}
                >
                  <NavItem selected={webMap}>Web Map</NavItem>
                </Link>
              )}
              {userDetails?.web_portal_access && (
                <Link
                  to="/new-upload"
                  // onClick={() => (window.location.href = "/new-upload")}
                >
                  <NavItem selected={newUpload}>Data Extract</NavItem>
                </Link>
              )}
              {userDetails?.web_portal_access && (
                <Link
                  to="/processed-files"
                  // onClick={() => (window.location.href = "/processed-files")}
                >
                  <NavItem selected={processedFiles}>
                    My Processed Files
                  </NavItem>
                </Link>
              )}
              {userDetails?.web_portal_access && (
                <Link
                  to="/req-models"
                  // onClick={() => (window.location.href = "/req-models")}
                >
                  <NavItem selected={reqModels}>Request Module Access</NavItem>
                </Link>
              )}
            </>
          )}
          {userDetails?.user_role === "reporting" && (
            <>
              {userDetails?.web_portal_access && (
                <Link
                  to="/home"
                  // onClick={() => (window.location.href = "/home")}
                >
                  <NavItem selected={newLandingHome}>HOME</NavItem>
                </Link>
              )}
              {userDetails?.dashboard_access && (
                <Link
                  to="/dashboard"
                >
                  <NavItem selected={dashboard}>DASHBOARD</NavItem>
                </Link>
              )}

              {userDetails?.web_map_access === true && (
                <Link
                  to="/web-map"
                  // onClick={() => (window.location.href = "/web-map")}
                >
                  <NavItem selected={webMap}>Web Map</NavItem>
                </Link>
              )}
              {userDetails?.web_portal_access && (
                <Link
                  to="/new-upload"
                  // onClick={() => (window.location.href = "/new-upload")}
                >
                  <NavItem selected={newUpload}>Data Extract</NavItem>
                </Link>
              )}
              {userDetails?.web_portal_access && (
                <Link
                  to="/processed-files"
                  // onClick={() => (window.location.href = "/processed-files")}
                >
                  <NavItem selected={processedFiles}>Processed Files</NavItem>
                </Link>
              )}
              {userDetails?.web_portal_access && (
                <Link
                  to="/req-models"
                  // onClick={() => (window.location.href = "/req-models")}
                >
                  <NavItem selected={reqModels}>Request Module Access</NavItem>
                </Link>
              )}
            </>
          )}
          <HeaderActionSection isAllowedWebPortal={userDetails?.web_portal_access}>
          <IconButton
            onClick={() => {
              setOpenDrawyer(true);
              resetAllNotifications();
            }}
          >
            <Badge badgeContent={notificationCount} color="primary">
              <IoNotifications />
            </Badge>
          </IconButton>
          <Avatar alt="Remy Sharp" style={{ marginLeft: "30px" }}>
            {userDetails?.name?.charAt(0)}
          </Avatar>
          <IconButton
            aria-controls="basic-menu"
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <RiArrowDropDownLine />
          </IconButton>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
          <UserDetailContainer>
            <UserName>{userDetails?.name}</UserName>
            <UserType>
              {userDetails?.user_role === "reporting" && "reporting user"}
              {userDetails?.user_role === "super_admin" && "super admin"}
              {userDetails?.user_role === "user" && "user"}
              {userDetails?.user_role === "admin" && "admin"}
            </UserType>
          </UserDetailContainer>
            <MenuItem onClick={() => handleLogout(instance)}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/*<RiLogoutBoxRLine
                  style={{ color: "#006F35", marginRight: "20px" }}
                  size={20}
                />*/}
                Logout
              </div>
            </MenuItem>
          </Menu>
          </HeaderActionSection>
        </NavContainer>
      </HeaderBar>
    </>
  );
}

export default Header;
